import styles from './Inicio.module.css';
import backgroundInicio from 'imagens/backgroundInicio.png';
import CardsInformacoes from 'components/CardInformacoes';
import Videos from 'components/Videos'
import Button from '@mui/material/Button';
import { Grid } from '@material-ui/core';
import React from 'react';
import { DeviceProvider, useDevice } from 'components/DeviceContext.js';
import VideosDepoimento from 'components/VideoDepoimentos';
import { Card1, Card2 } from 'components/Card';
import { RedesSociaisbranco } from 'components/RedesSociais'
import { Link } from 'react-router-dom';
import Noticias from 'components/Noticias'
import CookieBanner from 'components/Cookies';

function Inicio() {
    const { isMobile, isTablet, isLaptop } = useDevice();

    return (
        <DeviceProvider>
            <Grid container
                style={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundImage: `url(${backgroundInicio})`,
                    backgroundSize: isMobile ? '700px' : isTablet ? '1400px' : isLaptop ? 'cover' : 'cover',
                    backgroundColor: isMobile ? 'var(--azul-vivido)' : isTablet ? 'var(--azul-vivido)' : '',
                    height: isMobile ? '92vh' : isTablet ? '91vh' : isLaptop ? '80vh' : '90vh',
                    color: 'var(--branco)',
                    backgroundPosition: isMobile ? '90% bottom' : isTablet ? 'right bottom' : isLaptop ? 'bottom' : 'bottom',
                    backgroundRepeat: 'no-repeat',
                    padding: isMobile || isTablet ? '2em' : '0',
                }}
            >
                <Grid item xs={12} sm={12} md={3} lg={3} style={{ marginLeft: isMobile || isTablet ? '0' : '6rem', display: 'flex', flexDirection: 'column', alignItems: isMobile || isTablet ? 'center' : '' }}>
                    <h1
                        className={styles.titulo}
                        style={{
                            fontSize: isMobile ? '1.8rem' : isTablet ? '2.4rem' : isLaptop ? '2.5rem' : '3.7rem',
                            textAlign: isMobile || isTablet ? 'center' : 'left',
                            marginBottom: '1rem',
                            color: 'var(--branco)',
                        }}
                    >
                        Municípios pela infância e Adolescência
                    </h1>
                    <h2
                        style={{
                            fontWeight: '300',
                            fontSize: isMobile ? '1.3rem' : isLaptop ? '1.4rem' : '1.7rem',
                            textAlign: isMobile || isTablet ? 'center' : 'left',
                        }}
                    >
                        Sensibilize a população do seu Município a destinar o imposto de renda para o FIA-M e financie projetos socias locais.
                    </h2>
                    <Link to="/saiba-como" >
                        <Button variant="outlined" style={{
                            backgroundColor: 'var(--laranja)',
                            color: 'var(--branco)',
                            width: isMobile ? '190px' : isLaptop ? '200px' : '300px',
                            marginBottom: isMobile || isTablet ? '3rem' : '6rem',
                            borderRadius: '1.2em',
                            border: 'none',
                            fontSize: isMobile ? '' : isLaptop ? '1.1em' : '1.4em',
                            marginLeft: isMobile ? '0.5em' : isTablet ? '' : ''
                        }} >
                            Saiba Como
                        </Button>
                    </Link>
                </Grid>
                <Grid item xs={12} sm={7} >
                    <Grid container justifyContent="flex-end" alignItems="baseline" style={{ position: 'absolute', top: '150px', right: isMobile || isTablet ? '50px' : isLaptop ? '300px' : '400px', height: 'auto', display: isMobile ? 'none' : '' }}>
                        <RedesSociaisbranco />
                    </Grid>
                </Grid>
            </Grid>
            <Grid>
                <CardsInformacoes />
            </Grid>
            <Grid align='center'>
                <Grid item xs={12} sm={12} md={10} lg={11} xl={9} style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: isMobile || isTablet ? 'column' : '',
                    textAlign: 'left',
                    paddingBottom: '3em'
                }}>
                    <Card1 />
                    <Card2 />
                </Grid>
            </Grid>
            <Grid>
                <Noticias />
            </Grid>
            <Videos />
            <VideosDepoimento />
            <CookieBanner />
        </DeviceProvider>
    );
}

export default Inicio;
